module.exports = __webpack_public_path__ + "c18d597daf52bd2efba1694e3846c877.png";